import React, { useEffect, useState } from 'react';
import { useWebAuth } from '../../context/WebAuthContext';
import WebLogin from './WebLogin';

const AuthRouter = ({ children }) => {
  const { webUser, loading } = useWebAuth();
  const [isTelegramUser, setIsTelegramUser] = useState(false);
  // Убираем useLocation() отсюда

  useEffect(() => {
    // Проверяем, открыто ли приложение в Telegram
    const hasTelegram = !!window.Telegram?.WebApp?.initDataUnsafe?.user;
    setIsTelegramUser(hasTelegram);
    console.log("🔐 AuthRouter: isTelegramUser =", hasTelegram);
  }, []);

  // Для Telegram пользователей - показываем без задержки
  if (isTelegramUser) {
    console.log("🔐 AuthRouter: Telegram user, rendering app");
    return <>{children}</>;
  }

  // Показываем загрузку только для веб-пользователей
  if (loading) {
    console.log("🔐 AuthRouter: Loading...");
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#180749] to-[#2a0f6e] flex items-center justify-center">
        <div className="text-white text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p>Загрузка...</p>
        </div>
      </div>
    );
  }

  // Если это веб-пользователь и он авторизован - показываем приложение
  if (webUser) {
    console.log("🔐 AuthRouter: Web user logged in, rendering app");
    return <>{children}</>;
  }

  // Иначе показываем форму входа
  console.log("🔐 AuthRouter: No user, showing login form");
  return <WebLogin />;
};

export default AuthRouter;